import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';

import apiCalls from '../../utils/apiCalls';
import utils from '../../utils/utils';

import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faReceipt, faTimes } from '@fortawesome/free-solid-svg-icons';
import RefundForm from '../emails/refundForm';
import Modal from 'react-bootstrap/Modal';
import PaymentForm from './paymentForm';
import OrderForm from './orderForm';
import DATE_FORMAT from '../../components/constants/dateFormat';
import OrderBatchForm from './orderBatchForm';
import AddressModal from './addressModal';
import Loader from '../../components/loader';
import ErrorMessage from '../../components/errorMessage';

const AdminOrderView = ({ match }) => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [orders, setOrders] = useState(null);
  const [orderBatch, setOrder] = useState(null);
  const [user, setUser] = useState(null);
  const [refundPayment, setRefundPayment] = useState(null);
  const [editPayment, setEditPayment] = useState(null);
  const [editOrder, setEditOrder] = useState(null);
  const [editAddress, setEditAddress] = useState(null);
  const [showAddressCreate, setShowAddressCreate] = useState(false);
  const [editDeliveryDayId, setEditDeliveryDayId] = useState(null);

  useEffect(() => {
    getOrderBatch();
  }, []);

  function getOrderBatch() {
    apiCalls
      .getOrderBatches({
        orderBatchId: match.params.orderBatchId,
      })
      .then((result) => {
        if (result.data && result.data.orderBatches.length) {
          setOrder(result.data.orderBatches[0]);
          setLoading(false);
        }

        return apiCalls.getOrders({
          orderBatchId: result.data.orderBatches[0].id,
        });
      })
      .then((result) => {
        setOrders(result.data.orders);
        return result.data.orders[0].user.id;
      })
      .then((userId) => {
        return apiCalls.getUsersAdmin({
          userId: userId,
        });
      })
      .then((response) => {
        setUser(response.data.users[0]);
      })
      .catch((errors) => {
        setError(utils.getErrorMessageFromResponse(errors));
        setLoading(false);
      });
  }

  const errorMessage = error ? (
    <div className="row m-t-5 m-b-5">
      <div className="col-12">
        <div className="alert alert-error">{error}</div>
      </div>
    </div>
  ) : (
    ''
  );

  const timeRangeObjects = [];

  if (orders && orders.length) {
    orders.forEach((order) => {
      if (
        order.timeRange &&
        !timeRangeObjects.some(
          (timeRangeObj) => timeRangeObj.timeRange && timeRangeObj.timeRange.id === order.timeRange.id
        )
      ) {
        timeRangeObjects.push({
          timeRange: order.timeRange,
          deliveryDate: order.deliveryDate,
          deliveryDayId: order.deliveryDayId,
        });
      } else if (!order.timeRange && !timeRangeObjects.some((timeRangeObj) => timeRangeObj.timeRange === null)) {
        timeRangeObjects.push({
          timeRange: null,
          deliveryDate: order.deliveryDate,
          deliveryDayId: order.deliveryDayId,
        });
      }
    });
  }

  return (
    <div className="m-b-6 admin">
      <h3>
        <FormattedMessage
          id={'order.view.panel.title'}
          values={{
            id: orderBatch ? orderBatch.id : '-',
          }}
        />
      </h3>

      <Loader show={loading} />
      <ErrorMessage error={error} />

      {orderBatch ? (
        <div>
          <div className="text-muted m-b-3">
            <div>
              <small>
                <FormattedMessage
                  id={'order.view.date.created'}
                  values={{
                    date: utils.getFormattedDateFromString(
                      orderBatch.dateCreated,
                      DATE_FORMAT.displayWithTimeAndWeekday
                    ),
                  }}
                />
              </small>
            </div>
            <div>
              <small>
                <FormattedMessage
                  id={'order.view.platform'}
                  values={{
                    platform: orderBatch.platform,
                  }}
                />
              </small>
            </div>
          </div>
          <div className="row">
            <div className="col-12 col-md-6">
              <div className="m-b-3">
                {orderBatch.businessProfile ? (
                  <>
                    <h5>
                      <FormattedMessage
                        id={'order.view.user.order.creator.b2b'}
                        values={{
                          user: `${orderBatch.businessProfile.companyName}`,
                        }}
                      />
                    </h5>
                    {orderBatch.businessProfile.stripeCustomerId ? (
                      <div className="text-muted">
                        <small>
                          <FormattedMessage id={'order.view.user.stripe.user'} />:{' '}
                          <a
                            target="_blank"
                            href={`https://dashboard.stripe.com/customers/${orderBatch.businessProfile.stripeCustomerId}`}
                          >
                            {orderBatch.businessProfile.stripeCustomerId}
                          </a>
                        </small>
                      </div>
                    ) : (
                      ''
                    )}
                    <div>
                      <small>
                        <Link to={`/admin/users/${orderBatch.user.id}`}>
                          <FormattedMessage
                            id={'order.view.user.order.creator'}
                            values={{ user: `#${orderBatch.user.id} ${orderBatch.user.screenName}` }}
                          />
                        </Link>
                      </small>
                    </div>
                  </>
                ) : (
                  <Link to={`/admin/users/${orderBatch.user.id}`}>
                    <h5 className="m-b-1">
                      <FormattedMessage
                        id={'order.view.user.order.creator'}
                        values={{ user: `#${orderBatch.user.id} ${orderBatch.user.screenName}` }}
                      />
                    </h5>
                  </Link>
                )}
                {user ? (
                  <div className="text-muted">
                    <small>{user.contact}</small>
                  </div>
                ) : (
                  ''
                )}
              </div>

              {orderBatch.address ? (
                <>
                  <div>
                    <h4>
                      <FormattedMessage
                        id={'order.view.user.order.recipient'}
                        values={{ user: `${orderBatch.address.customerName}` }}
                      />
                    </h4>
                  </div>
                  <div>
                    <strong>
                      <FormattedMessage id={'order.view.user.address.street'} />
                    </strong>
                    : {orderBatch.address.street}
                  </div>
                  <div>
                    <strong>
                      <FormattedMessage id={'order.view.user.address.unit'} />
                    </strong>
                    : {orderBatch.address.unit}
                  </div>
                  <div>
                    <strong>
                      <FormattedMessage id={'order.view.user.address.post.code'} />
                    </strong>
                    : {orderBatch.address.postCode}
                  </div>
                  <div>
                    <strong>
                      <FormattedMessage id={'order.view.user.address.city'} />
                    </strong>
                    : {orderBatch.address.city}
                  </div>
                  <div>
                    <strong>
                      <FormattedMessage id={'order.view.user.address.country'} />
                    </strong>
                    : {orderBatch.address.country}
                  </div>
                  <div>
                    <strong>
                      <FormattedMessage id={'order.view.user.phone.number'} />
                    </strong>
                    :{' '}
                    <a className="link" href={`tel:${orderBatch.address.phoneNumber}`}>
                      {orderBatch.address.phoneNumber}
                    </a>
                  </div>
                  <div>
                    <button onClick={() => setEditAddress(orderBatch.address)} className="btn btn-normal-link">
                      <FormattedMessage id={'order.view.order.batch.address.edit'} />
                    </button>
                  </div>
                </>
              ) : (
                <div>
                  <button onClick={() => setShowAddressCreate(true)} className="btn btn-normal-link">
                    <FormattedMessage id={'order.view.order.batch.address.create'} />
                  </button>
                </div>
              )}
            </div>
            <div className="col-12 col-md-6">
              <h4>
                <FormattedMessage
                  id={'order.view.payment.header'}
                  values={{
                    paymentId: orderBatch.payment.id,
                  }}
                />
              </h4>
              <p>
                <button className="btn btn-normal-link" onClick={() => setEditPayment(orderBatch.payment)}>
                  <FormattedMessage id={'order.view.payment.edit'} />
                </button>
              </p>
              <div className="">
                <strong>
                  <FormattedMessage id={'order.view.payment.amount.label'} />
                </strong>
                : {orderBatch.payment.amount}€
              </div>
              <div className="">
                <strong>
                  <FormattedMessage id={'order.view.payment.status.label'} />
                </strong>
                : {orderBatch.payment.status}
              </div>
              {orderBatch.payment.invoicePaymentStatus ? (
                <div className="">
                  <strong>
                    <FormattedMessage id={'order.view.invoice.payment.status.label'} />
                  </strong>
                  :{' '}
                  <FormattedMessage
                    id={`admin.orders.order.invoice.payment.status.${orderBatch.payment.invoicePaymentStatus}`}
                  />
                </div>
              ) : (
                ''
              )}
              {orderBatch.payment.className === 'CardPayment' ? (
                <>
                  <div className="">
                    <strong>
                      <FormattedMessage id={'order.view.payment.intent.status.label'} />
                    </strong>
                    : {orderBatch.payment.paymentIntentStatus}
                  </div>
                  <div className="">
                    <strong>
                      <FormattedMessage id={'order.view.payment.intent.id.label'} />
                    </strong>
                    :{' '}
                    <a
                      className="link"
                      href={`https://dashboard.stripe.com/payments/${orderBatch.payment.paymentIntentId}`}
                      target="_blank"
                    >
                      {orderBatch.payment.paymentIntentId}
                    </a>
                  </div>
                </>
              ) : (
                ''
              )}
              <div className="m-b-6">
                <div>
                  <strong>
                    <FormattedMessage id={'order.view.payment.refunds'} />
                  </strong>{' '}
                  <button className="btn btn-normal-link" onClick={() => setRefundPayment(orderBatch.payment)}>
                    <FormattedMessage id={'admin.delivery.day.marketplace.table.column.actions.refund'} />
                  </button>
                  :
                </div>
                <ul>
                  {orderBatch.payment.refunds.map((refund, index) => (
                    <li>
                      {refund.amount}€ - "{refund.comment}"
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>

          <hr className="m-b-3" />

          <div className="m-b-3">
            {timeRangeObjects.map((timeRangeObj, index) => (
              <>
                <div>📆 {utils.getFormattedDateFromString(timeRangeObj.deliveryDate, DATE_FORMAT.displayOnlyDate)}</div>
                {timeRangeObj.timeRange ? (
                  <div>
                    ⏱ {utils.getFormattedTimeRange(timeRangeObj.timeRange)} - #{timeRangeObj.timeRange.id}
                  </div>
                ) : (
                  ''
                )}

                <div>
                  <button
                    onClick={() => setEditDeliveryDayId(timeRangeObj.deliveryDayId)}
                    className="btn btn-link btn-normal-link text-muted"
                  >
                    <FormattedMessage id={'order.view.order.batch.edit.delivery.day.time'} />
                  </button>
                </div>
              </>
            ))}
          </div>

          {orders
            ? orders.map((order) => {
                return (
                  <>
                    <h3>
                      {order.marketplaceName} - {order.finalSum}€
                    </h3>
                    <div className="text-muted">
                      #{order.id}{' '}
                      <u onClick={() => setEditOrder(order)}>
                        <FormattedMessage id={'order.view.order.edit'} />
                      </u>
                    </div>
                    {order.packer ? (
                      <div className="text-muted">
                        <FormattedMessage id={'order.view.order.packer'} values={{ packer: order.packer.screenName }} />
                      </div>
                    ) : (
                      ''
                    )}
                    <div className="m-b-2 text-muted">
                      <small>{utils.getFormattedDateRangeFromStrings(order.deliveryFrom, order.deliveryTo)}</small>
                    </div>
                    <table className="table table-striped m-b-6">
                      <thead>
                        <th scope="col">
                          <FormattedMessage id={'order.view.table.column.item.id'} />
                        </th>
                        <th scope="col">
                          <FormattedMessage id={'order.view.table.column.item.name'} />
                        </th>
                        <th scope="col">
                          <FormattedMessage id={'order.view.table.column.price'} />
                        </th>
                        <th scope="col">
                          <FormattedMessage id={'order.view.table.column.quantity'} />
                        </th>
                      </thead>
                      <tbody>
                        {order.items.map((orderItem, index) => (
                          <tr key={index}>
                            <th scope="row">
                              <Link to={`/item/${orderItem.item.id}`} className="link">
                                {orderItem.item.id}
                              </Link>
                            </th>
                            <td>
                              <div>{orderItem.itemName}</div>
                              {orderItem.stripeInvoiceItemId ? (
                                <div className="text-muted">
                                  <small>{orderItem.stripeInvoiceItemId}</small>
                                </div>
                              ) : (
                                ''
                              )}
                            </td>
                            <td>{orderItem.itemPrice}€</td>
                            <td>{orderItem.quantity}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </>
                );
              })
            : ''}

          {orderBatch.coupon ? (
            <p className="text-right m-b-1 text-large">
              <FormattedMessage id={'order.view.payment.coupon'} /> {orderBatch.coupon.code}{' '}
              {orderBatch.coupon.discountPercent != null ? (
                <span>-{orderBatch.coupon.discountPercent}%</span>
              ) : (
                <span>-{orderBatch.coupon.discountSum}€</span>
              )}
            </p>
          ) : (
            ''
          )}
          <p className="text-right m-b-1 text-large">
            <FormattedMessage
              id={'order.view.delivery.fee'}
              values={{
                sum: orderBatch.deliveryFee,
              }}
            />
          </p>
          <h3 className="text-right m-b-6">
            <FormattedMessage
              id={'order.view.total'}
              values={{
                sum: orderBatch.finalSum,
              }}
            />
          </h3>
        </div>
      ) : (
        ''
      )}

      <Modal show={!!refundPayment} onHide={() => setRefundPayment(null)} size="lg">
        <div onClick={() => setRefundPayment(null)} className="b-modal-close">
          <FontAwesomeIcon icon={faTimes} />
        </div>

        <div className="b-modal">
          {refundPayment ? (
            <RefundForm
              payment={refundPayment}
              closeModal={() => {
                setRefundPayment(null);
                getOrderBatch();
              }}
            />
          ) : (
            ''
          )}
        </div>
      </Modal>

      <Modal show={!!editPayment} onHide={() => setEditPayment(null)} size="lg">
        <div onClick={() => setEditPayment(null)} className="b-modal-close">
          <FontAwesomeIcon icon={faTimes} />
        </div>

        <div className="b-modal">
          {editPayment ? (
            <PaymentForm
              paymentId={editPayment.id}
              onSuccess={() => {
                setEditPayment(null);
                getOrderBatch();
              }}
            />
          ) : (
            ''
          )}
        </div>
      </Modal>

      <Modal show={!!editOrder} onHide={() => setEditOrder(null)} size="lg">
        <div onClick={() => setEditOrder(null)} className="b-modal-close">
          <FontAwesomeIcon icon={faTimes} />
        </div>

        <div className="b-modal">
          {editOrder ? (
            <OrderForm
              orderId={editOrder.id}
              onSuccess={() => {
                setEditOrder(null);
                getOrderBatch();
              }}
            />
          ) : (
            ''
          )}
        </div>
      </Modal>
      <Modal show={!!editAddress} onHide={() => setEditAddress(null)} size="lg">
        <div onClick={() => setEditAddress(null)} className="b-modal-close">
          <FontAwesomeIcon icon={faTimes} />
        </div>

        <div className="b-modal">
          {editAddress ? (
            <AddressModal
              existingAddress={editAddress}
              onSuccess={() => {
                setEditAddress(null);
                getOrderBatch();
              }}
            />
          ) : (
            ''
          )}
        </div>
      </Modal>
      <Modal show={!!showAddressCreate} onHide={() => setShowAddressCreate(false)} size="lg">
        <div onClick={() => setShowAddressCreate(false)} className="b-modal-close">
          <FontAwesomeIcon icon={faTimes} />
        </div>

        <div className="b-modal">
          {showAddressCreate ? (
            <AddressModal
              orderBatchId={orderBatch.id}
              onSuccess={() => {
                setShowAddressCreate(false);
                getOrderBatch();
              }}
            />
          ) : (
            ''
          )}
        </div>
      </Modal>
      <Modal show={!!editDeliveryDayId} onHide={() => setEditDeliveryDayId(null)} size="lg">
        <div onClick={() => setEditDeliveryDayId(null)} className="b-modal-close">
          <FontAwesomeIcon icon={faTimes} />
        </div>

        <div className="b-modal">
          {editDeliveryDayId ? (
            <OrderBatchForm
              orderBatch={orderBatch}
              deliveryDayId={editDeliveryDayId}
              onSuccess={() => {
                setEditDeliveryDayId(null);
                getOrderBatch();
              }}
            />
          ) : (
            ''
          )}
        </div>
      </Modal>
    </div>
  );
};

AdminOrderView.propTypes = {
  currentUser: PropTypes.object,
};

AdminOrderView.defaultProps = {};

function mapStateToProps(state) {
  return {
    currentUser: state.currentUser.user,
  };
}

export default injectIntl(connect(mapStateToProps)(AdminOrderView));
